<template>
  <div class="form">
    <div class="form__header">
      <h3>{{data.data ? 'Просмотр' : 'Добавить тренажёр' }}</h3>
    </div>

    <div class="form__body">
      <div class="selected-trainers">
        <span 
          v-for="(item, i) in trainersToAdd" 
          :key="item.id"
          @click="trainersToAdd.splice(i, 1)"
        >
          {{ item.trainer.title }}
        </span>
      </div>

      <p class="form__field" v-show="!data.data && trainersToAdd.length < 2">
        <span>Тренажер:</span>        
        <v-select 
          @input="getTrainerSettings(trainer)" 
          label="title" 
          :options="trainersList" 
          v-model="trainer" 
          :appendToBody="false"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.title }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.title }}
            </div>
          </template>
        </v-select>        
      </p>

      <div class="settings" v-if="trainer && trainersToAdd.length < 2">
        <p class="form__field range" v-show="!data.data && trainer.component !=='texts'">
          <span>Количество: ({{ trainerData.qnt }})</span>
          <range-slider
            class="setup__range"
            min="1"
            max="30"
            step="1"
            v-model="trainerData.qnt">
          </range-slider>
        </p> 

        <p class="form__field" v-show="trainer.component === 'texts'">
          <span>Уровень:</span>        
          <v-select 
            :options="[
              { label: 'до 30 слов/мин.', id: 1 },
              { label: 'от 30 до 80 слов/мин.', id: 2 },
              { label: 'от 80 слов/мин.', id: 3 }
            ]" 
            v-model="level" 
            :appendToBody="false"
            class="required"
            :class="{
              valid: level,
              invalid: !level,
            }"
            :reduce="option => option.id"
          >
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.label }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>        
        </p>

        <component 
          class="instructions"
          :is="trainerSettings" 
          @params_changed="changeTrainerParams"
          :is_homework="true"
          :homework_params="data.data ? data.data.params : null"
        ></component>

        <a 
          v-show="addBtnEnable" 
          class="add-btn" 
          href="#" 
          @click.prevent="addTrainer"
        >
          Добавить
        </a>
      </div>
    </div>

    <div class="form__footer" v-show="!data.data">
      <p class="warning-message" v-show="trainersToAdd.length === 2"> Внимание! После сохранение изменить настойки будет нельзя!</p>
      <button 
        type="button" 
        class="uk-button uk-button-primary" 
        :disabled="trainersToAdd.length !== 2" 
        @click="submit"
      >
        Сохранить
      </button>
    </div> 
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RangeSlider from 'vue-range-slider'
import swal from 'sweetalert'
import vSelect from 'vue-select'

export default {
  props: ['data', 'is_prog'],
  components: { RangeSlider, vSelect },
  inject: ['http'],
  data() {
    return {
      level: '',
      trainer: null,
      trainerSettings: null,
      trainerData: {
        trainer: null,
        params: {},
        qnt: 1
      },
      trainersToAdd: []
    }
  },
  computed: {
    ...mapState({
      trainers: state => state.train.trainers
    }),
    addBtnEnable() {
      if (!this.data.data) {
        if (this.trainer.component === 'texts') {
          return this.level ? true : false
        } else {
          return this.trainerSettings ? true : false
        }
      } else {
        return false
      }      
    },
    trainersList() {
      let list = _.cloneDeep(this.trainers)
      if (this.is_prog) {
        return list.filter(item => item.component === 'bee' || item.component === 'gorbov')
      } else {
        return list.filter(item => item.component === 'bee' || item.component === 'texts')
      }
  
    }
  },
  methods: {
    changeTrainerParams(params) {
      this.trainerData.params = Object.assign({}, params)
    },
    addTrainer() {
      if (this.trainerData.trainer.component === 'texts') {
        this.trainerData.level = this.level
      }
      let exist = this.trainersToAdd.find(t => t.trainer.id === this.trainerData.trainer.id)
      if (!exist) {
        this.trainersToAdd.push(this.trainerData)
        this.trainerData = {
          trainer: null,
          params: {},
          qnt: 1
        }
        this.trainerSettings = null
        this.trainer = null
      } else {
        swal('', 'Такой тренажер уже есть', 'warning')
      }   
    },
    getTrainerSettings(trainer) {
      this.trainerData.trainer = {
        id: trainer.id,
        title: trainer.title,
        component: trainer.component
      }

      if (trainer.component !== 'texts') {
        this.trainerSettings = require(`../../trainer/${trainer.component}/components/Settings`).default;
      } else {
        this.trainerSettings = 'text'
      }
    },
    submit() {
      let data = {
        student_id: this.data.id,
        trainers: this.trainersToAdd
      }
      this.http.post('onSaveMemberTrainers', data).then(res => {
        this.$emit('add-trainers', data)
        this.$emit('close-popup')
        swal('Успешно!', 'Задания добавлены', 'success')
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }
  },
  created() {
    if (this.data.data) {
      this.trainerData = this.data.data

      if (this.data.data.trainer) {
        this.getTrainerSettings(this.data.data.trainer)
          
        this.trainer = this.data.data.trainer 

        //###### для старых тренажеров #########
        let val = {
          train: this.trainer.component + '_params',
          params: this.data.data.params,
        }
        this.$store.commit('train/changeParams', val);
        // #################
      }
    }          
  }
}
</script>

<style lang="scss" scoped>
.form {
  min-height: 400px;
}

.instructions {
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
}

.range {
  align-items: center;
  font-size: 16px;
}

.range-slider {
  width: 100%;
}

.settings {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.selected-trainers {
  display: flex;
  width: 100%;
  margin-bottom: 20px;

  & span {
    padding: 10px;
    border: 2px solid #1e87f0;
    border-radius: 6px;
    margin-right: 10px;
    cursor: pointer;
  }
}

.form__body {
  padding-bottom: 80px;
}
</style>